<template>
    <div
        class="story-maker-sticker story-maker-sticker-music-missing"
        :style="{
            top: `${$attrs.position.y}%`,
            left: `${$attrs.position.x}%`,
            transform: isCover || isPreventCover ? `translate(-50%, -50%) scale(${$attrs.transform.scale}) rotate(${$attrs.transform.rotate}deg)` : ''
        }"
    >
        <div class="sticker sticker-music-missing">
            <i class="fa-solid fa-music"></i>
            <i class="fa-solid fa-triangle-exclamation"></i>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isEditing: Boolean,
        isPreventCover: Boolean,
        isCover: Boolean,
    }
}
</script>

<style scoped>
.story-maker-sticker-music-missing {
    position: absolute;
    cursor: pointer;
}
.sticker-music-missing {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 8px 12px;
    border-radius: 20px;
    background: rgba(0, 0, 0, 0.55);
    color: #f5a623;
    font-size: 14px;
}
.sticker-music-missing .fa-triangle-exclamation {
    color: #f5a623;
}
</style>
